export default defineNuxtRouteMiddleware((to, from) => {
    // Middleware vazio - a verificação é feita pelo ContractModal.vue
    // Este middleware existe apenas para garantir que o ContractModal seja renderizado
})
